<p-dialog
  (onHide)="onCloseCadastroRepresentacaoDialog()"
  [(visible)]="showCadastroTipoRepresentacaoDialog"
  [breakpoints]="{ '1080px': '90vw', '640px': '95vw' }"
  [closable]="false"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '50vw', maxWidth: '90vw' }"
>
  <ng-template pTemplate="header">
    <div class="flex items-start justify-between w-full">
      <div class="flex flex-col">
        <h2 class="text-xl font-bold text-gray-800">Cadastro de Representação</h2>
      </div>
    </div>
  </ng-template>

  @if (showCadastroTipoRepresentacaoDialog) {
    <app-form-representacao-govbr mode="cadastro"/>
  }

  <ng-template pTemplate="footer">
    <div class="flex flex-1 w-full justify-end items-center gap-2 pt-2 border-t-[#E41B2E]">
      <button (click)="onCloseCadastroRepresentacaoDialog()"
              [disabled]="showLoadingSaveButton"
              class="p-button-secondary button-cancel"
              pButton type="button">
        <app-icon-bold-close-square/>
        Cancelar
      </button>
      <button (click)="formRepresentacaoGovbrComponent.submit()"
              [loading]="showLoadingSaveButton"
              class="btn-primary"
              pButton type="button">
        <app-icon-bold-ram-2 [hidden]="showLoadingSaveButton"/>
        {{ showLoadingSaveButton ? 'Redirecionando...' : 'Salvar' }}
      </button>
    </div>
  </ng-template>
</p-dialog>
